import React, { useState, useEffect } from 'react';
import {
  FiPlus,
  FiEdit,
  FiTrash2,
  FiEye,
  FiX,
  FiSearch,
  FiBarChart2,
  FiCheckCircle,
  FiClock,
  FiFileText,
  FiUpload,
  FiImage,
  FiSave,
  FiUser,
  FiRefreshCw,
  FiFilter,
  FiCalendar,
  FiDownload,
  FiArrowUp,
  FiArrowDown,
  FiChevronLeft,
  FiChevronRight,
  FiStar,
  FiHeart,
  FiMenu,
  FiHome,
  FiSettings,
  FiInfo,
  FiFile
} from 'react-icons/fi';
import {
  FaNewspaper,
  FaRegEye,
  FaCheckCircle,
  FaRegClock,
  FaSort,
  FaSortUp,
  FaSortDown
} from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BlogDashboard = () => {
  // State management
  const [blogs, setBlogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [editingBlog, setEditingBlog] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewBlog, setViewBlog] = useState(null);
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCategory, setFilterCategory] = useState('all');
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'asc' });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [imageUploads, setImageUploads] = useState({
    main_img: null,
    small_img: null,
    list_img: []
  });
  const [imagePreviews, setImagePreviews] = useState({
    main_img: null,
    small_img: null,
    list_img: []
  });
  const [categories, setCategories] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);


  // Form data state
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    status: 'active',
    content: '',
    excerpt: '',
    tags: '',
    // author: ''
  });

  // Check mobile screen
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // API base URL - replace with your actual API endpoint
  const API_BASE_URL = 'http://192.250.226.161:3002/api/admin/blogs';

  // Utility function to ensure list_img is always an array
  const ensureListImgIsArray = (blog) => {
    if (!blog.list_img) {
      return [];
    }
    if (Array.isArray(blog.list_img)) {
      return blog.list_img;
    }
    if (typeof blog.list_img === 'string') {
      try {
        const parsed = JSON.parse(blog.list_img);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('Error parsing list_img:', error);
        return [];
      }
    }
    return [];
  };

  // Process blogs data to ensure list_img is always an array
  const processBlogsData = (blogsData) => {
    return blogsData.map(blog => ({
      ...blog,
      list_img: ensureListImgIsArray(blog)
    }));
  };
  // Open view modal with full blog object
  const viewBlogDetails = (blog) => {
    setViewBlog(blog || null);

    // prepare image previews for view modal (if you want)
    setImagePreviews({
      main_img: blog?.main_img || null,
      small_img: blog?.small_img || null,
      list_img: blog?.list_img || []
    });

    setShowViewModal(true);
  };



  // Safe capitalize helper
  const capitalize = (s) => (typeof s === 'string' && s.length) ? s.charAt(0).toUpperCase() + s.slice(1) : '';


  // Replace your existing fetchBlogs with this function
  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: '10',
        ...(searchTerm && { q: searchTerm }),
        ...(filterStatus !== 'all' && { status: filterStatus }),
        ...(filterCategory !== 'all' && { category: filterCategory })
      });

      const url = `${API_BASE_URL}?${params.toString()}`;
      console.log('Fetching blogs from:', url);

      const response = await fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Server ${response.status}: ${text}`);
      }

      const payload = await response.json();
      console.log('blogs payload:', payload);

      // backend uses: { success: true, totrow: n, data: [ ... ] }
      const blogsArray = Array.isArray(payload.data) ? payload.data : [];

      // map backend fields to frontend shape
      const mapped = blogsArray.map((row) => {
        // normalize list images to an array
        let listImgs = [];
        if (Array.isArray(row.news_img_list)) listImgs = row.news_img_list;
        else if (typeof row.news_img_list === 'string' && row.news_img_list.trim().length) {
          // server sometimes returns comma-separated string: "/upload/a.jpg, /upload/b.jpg"
          listImgs = row.news_img_list.split(',').map(s => s.trim()).filter(Boolean);
        }

        // server returns is_live as "Active"/"Inactive" string in your route mapping
        const status = (row.is_live === 1 || row.is_live === '1' || Number(row.is_live) === 1) ? 'active' : 'inactive';
        return {
          id: row.nid,
          title: row.news_title || '',
          category: row.category_name || '',
          main_img: row.news_img || '',
          small_img: row.news_img_small || '',
          list_img: listImgs,
          status,
          created_at: row.cr_date || row.post_date || '',
          excerpt: row.mdesc || '',
          content: row.news_det || '',
          tags: row.mkeyword || '',
          bcid: row.bcid ?? null
        };
      });

      setBlogs(mapped);
      setCategories([...new Set(mapped.map(b => b.category).filter(Boolean))]);
      // payload.totrow exists on backend; calculate pages from it
      const totalRows = typeof payload.totrow === 'number' ? payload.totrow : mapped.length;
      setTotalPages(Math.max(1, Math.ceil(totalRows / 10)));

      toast.success('Blogs loaded successfully!');
    } catch (error) {
      console.error('Error fetching blogs:', error);
      toast.error('Failed to fetch blogs. Using sample data instead.');
      const processedSampleBlogs = processBlogsData(sampleBlogs);
      setBlogs(processedSampleBlogs);
      setCategories([...new Set(processedSampleBlogs.map(b => b.category))]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };


  // Sample data for fallback
  const sampleBlogs = [
    {
      id: 1,
      blogscontetcount: "3515",
      category: "Science",
      title: "The Future of Space Exploration",
      main_img: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=400",
      small_img: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=200",
      list_img: [
        "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?w=300",
        "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=300"
      ],
      status: "active",
      created_at: "2025-10-27T11:18:32.000Z",
      updated_at: "2025-10-27T11:20:01.000Z",
      views: 1245,
      likes: 89,
      excerpt: "Exploring the future possibilities of space travel and colonization.",
      author: "John Smith",
      tags: "space, exploration, future"
    },
    {
      id: 2,
      blogscontetcount: "1046",
      category: "Technology",
      title: "AI Revolution in Healthcare",
      main_img: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=400",
      small_img: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=200",
      list_img: [
        "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=300"
      ],
      status: "active",
      created_at: "2025-10-27T11:20:12.000Z",
      updated_at: "2025-10-27T11:20:12.000Z",
      views: 892,
      likes: 67,
      excerpt: "How artificial intelligence is transforming healthcare delivery.",
      author: "Sarah Johnson",
      tags: "AI, healthcare, technology"
    },
    {
      id: 3,
      blogscontetcount: "5134",
      category: "Environment",
      title: "Sustainable Living Practices",
      main_img: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400",
      small_img: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=200",
      list_img: [
        "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=300"
      ],
      status: "inactive",
      created_at: "2025-10-27T11:20:15.000Z",
      updated_at: "2025-10-27T11:20:15.000Z",
      views: 567,
      likes: 42,
      excerpt: "Practical tips for adopting sustainable lifestyle choices.",
      author: "Mike Wilson",
      tags: "sustainability, environment, lifestyle"
    }
  ];

  // Initialize with API data
  useEffect(() => {
    fetchBlogs();
  }, [page, searchTerm, filterStatus, filterCategory]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle image upload with preview
  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      // Create preview URL
      const previewUrl = URL.createObjectURL(file);

      if (type === 'list_img') {
        setImageUploads({
          ...imageUploads,
          list_img: [...imageUploads.list_img, file]
        });
        setImagePreviews({
          ...imagePreviews,
          list_img: [...imagePreviews.list_img, previewUrl]
        });
      } else {
        setImageUploads({
          ...imageUploads,
          [type]: file
        });
        setImagePreviews({
          ...imagePreviews,
          [type]: previewUrl
        });
      }
      toast.success(`${type.replace('_', ' ')} uploaded successfully!`);
    }
  };

  // Remove uploaded image
  const removeImage = (type, index = null) => {
    if (type === 'list_img' && index !== null) {
      const newListImg = [...imageUploads.list_img];
      const newListPreview = [...imagePreviews.list_img];
      newListImg.splice(index, 1);
      newListPreview.splice(index, 1);

      setImageUploads({
        ...imageUploads,
        list_img: newListImg
      });
      setImagePreviews({
        ...imagePreviews,
        list_img: newListPreview
      });
    } else {
      setImageUploads({
        ...imageUploads,
        [type]: null
      });
      setImagePreviews({
        ...imagePreviews,
        [type]: null
      });
    }
    toast.info('Image removed');
  };

  // Toggle blog status
  const toggleBlogStatus = async (blog) => {
    const newStatus = blog.status === 'active' ? 'inactive' : 'active';

    setLoading(true);
    try {
      // send numeric is_live to match backend (1 = active, 0 = inactive)
      const newIsLive = newStatus === 'active' ? 1 : 0;

      const response = await fetch(`${API_BASE_URL}/${blog.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ is_live: newIsLive })
      });

      if (!response.ok) throw new Error('Failed to update status');

      const updatedBlogs = blogs.map(b =>
        b.id === blog.id ? { ...b, status: newStatus } : b
      );
      setBlogs(updatedBlogs);
      toast.success(`Blog status changed to ${newStatus}`);
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Failed to update blog status');
    } finally {
      setLoading(false);
    }
  };

  // POST - Create new blog (frontend)
  const createBlog = async (blogData) => {
    try {
      const fd = new FormData();
      // map to backend field names
      fd.append('news_title', blogData.title || '');
      fd.append('bcid', blogData.bcid ?? blogData.category ?? ''); // send either category id or bcid if you have it
      // is_live: backend uses numbers; send 1 or 0 (or whatever backend expects)
      fd.append('is_live', (blogData.status === 'active' ? '1' : '0'));
      fd.append('news_det', blogData.content || '');
      fd.append('mdesc', blogData.excerpt || '');
      fd.append('mkeyword', blogData.tags || '');
      // optional: post_date if needed
      fd.append('post_date', new Date().toISOString());

      // files must use backend field names expected by multer
      if (imageUploads.main_img) fd.append('news_img', imageUploads.main_img);
      if (imageUploads.small_img) fd.append('news_img_small', imageUploads.small_img);
      if (imageUploads.list_img && imageUploads.list_img.length) {
        imageUploads.list_img.forEach(img => fd.append('news_img_list', img));
      }

      const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: 'include',   // <- include cookies/session
        body: fd
      });

      if (!response.ok) {
        const txt = await response.text();
        throw new Error(`Server ${response.status}: ${txt}`);
      }

      const result = await response.json();
      // backend returns { success: true, data: newBlog } — map accordingly
      return result.data;
    } catch (error) {
      console.error('Error creating blog:', error);
      throw error;
    }
  };


  // PUT - Update blog
  const updateBlog = async (id, blogData) => {
    try {
      const formData = new FormData();
      formData.append('category', blogData.category);
      formData.append('title', blogData.title);
      formData.append('status', blogData.status);
      formData.append('content', blogData.content);
      formData.append('excerpt', blogData.excerpt);
      // formData.append('author', blogData.author);
      formData.append('tags', blogData.tags);

      // Append images if available
      if (imageUploads.main_img) {
        formData.append('main_img', imageUploads.main_img);
      }
      if (imageUploads.small_img) {
        formData.append('small_img', imageUploads.small_img);
      }
      if (imageUploads.list_img.length > 0) {
        imageUploads.list_img.forEach(img => {
          formData.append('list_img', img);
        });
      }

      const response = await fetch(`${API_BASE_URL}/${id}`, {
        method: 'PUT',
        body: formData,
        credentials: "include",
      });

      if (!response.ok) throw new Error('Failed to update blog');
      const result = await response.json();
      return processBlogsData([result.blog])[0];
    } catch (error) {
      console.error('Error updating blog:', error);
      throw error;
    }
  };

  // DELETE - Remove blog
  const deleteBlogAPI = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/${id}`, {
        method: 'DELETE',
        credentials: "include"
      });

      if (!response.ok) throw new Error('Failed to delete blog');
      return await response.json();
    } catch (error) {
      console.error('Error deleting blog:', error);
      throw error;
    }
  };

  // Save blog (add or edit)
  const saveBlog = async () => {
    setLoading(true);
    try {
      let result;
      if (editingBlog) {
        // Update existing blog
        result = await updateBlog(editingBlog.id, formData);
        const updatedBlogs = blogs.map(blog =>
          blog.id === editingBlog.id ? result : blog
        );
        setBlogs(updatedBlogs);
        toast.success('Blog updated successfully!');
      } else {
        // Add new blog
        result = await createBlog(formData);
        setBlogs([result, ...blogs]);
        toast.success('Blog created successfully!');
      }

      // Reset form and close modal
      resetForm();
      setShowModal(false);
      fetchBlogs(); // Refresh the list
    } catch (error) {
      toast.error('Error saving blog. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Edit blog
  const editBlog = (blog) => {
    setFormData({
      title: blog.title,
      category: blog.category,
      status: blog.status,
      content: blog.content || '',
      excerpt: blog.excerpt || '',
      // author: blog.author || '',
      tags: blog.tags || ''
    });
    setEditingBlog(blog);

    // Set image previews for editing
    setImagePreviews({
      main_img: blog.main_img,
      small_img: blog.small_img,
      list_img: blog.list_img || []
    });

    setShowModal(true);
    toast.info('Editing blog: ' + blog.title);
  };

  // Delete blog
  const deleteBlog = async (id) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      setLoading(true);
      try {
        await deleteBlogAPI(id);
        setBlogs(blogs.filter(blog => blog.id !== id));
        toast.success('Blog deleted successfully!');
        fetchBlogs(); // Refresh the list
      } catch (error) {
        toast.error('Error deleting blog. Please try again.');
      } finally {
        setLoading(false);
      }
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      title: '',
      category: '',
      status: 'active',
      content: '',
      excerpt: '',
      tags: '',
      // author: ''
    });
    setImageUploads({
      main_img: null,
      small_img: null,
      list_img: []
    });
    setImagePreviews({
      main_img: null,
      small_img: null,
      list_img: []
    });
    setEditingBlog(null);
  };

  // Show image in modal
  const showImage = (src) => {
    setSelectedImage(src);
    setShowImageModal(true);
  };

  // Handle sort
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    toast.info(`Sorted by ${key} ${direction === 'asc' ? 'ascending' : 'descending'}`);
  };

  // Filter blogs based on search and status (safe)
  const filteredBlogs = blogs.filter(blog => {
    const q = (searchTerm || '').toLowerCase();

    const title = (blog.title || '').toLowerCase();
    const category = (blog.category || '').toLowerCase();
    const author = (blog.author || '').toLowerCase();

    const matchesSearch =
      (title.includes(q)) ||
      (category.includes(q)) ||
      (author.includes(q));

    const matchesStatus = filterStatus === 'all' || blog.status === filterStatus;
    const matchesCategory = filterCategory === 'all' || blog.category === filterCategory;

    return matchesSearch && matchesStatus && matchesCategory;
  });


  // Sort blogs
  const sortedBlogs = [...filteredBlogs].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Calculate stats
  const totalBlogs = blogs.length;
  const totalViews = blogs.reduce((sum, blog) => sum + (blog.views || 0), 0);
  const activeBlogs = blogs.filter(blog => blog.status === 'active').length;
  const draftBlogs = blogs.filter(blog => blog.status === 'inactive').length;

  // Pagination
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Enhanced Responsive Styles
  const styles = {
    // Color variables
    colors: {
      primary: '#E36324',
      primaryLight: 'rgba(227, 99, 36, 0.1)',
      secondary: '#5DC350',
      secondaryLight: 'rgba(93, 195, 80, 0.1)',
      dark: '#2D3748',
      light: '#f8f9fa',
      gray: '#718096',
      danger: '#E53E3E',
      dangerLight: 'rgba(229, 62, 62, 0.1)',
      warning: '#D69E2E',
      warningLight: 'rgba(214, 158, 46, 0.1)',
      info: '#3182CE',
      infoLight: 'rgba(49, 130, 206, 0.1)',
      border: '#E2E8F0',
      shadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
      shadowHover: '0 10px 15px rgba(0, 0, 0, 0.1)',
      gradient: 'linear-gradient(135deg, #E36324 0%, #FF7B42 100%)'
    },

    // Global styles
    body: {
      backgroundColor: '#F7FAFC',
      color: '#2D3748',
      lineHeight: 1.6,
      margin: 0,
      padding: 0,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      minHeight: '100vh'
    },

    container: {
      maxWidth: 1400,
      margin: '0 auto',
      padding: isMobile ? '0 15px' : '0 20px'
    },

    // Header styles
    header: {
      background: 'linear-gradient(135deg, #E36324 0%, #FF7B42 100%)',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 100
    },

    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isMobile ? '15px 0' : '20px 0'
    },

    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: isMobile ? '1.2rem' : '1.5rem',
      fontWeight: 700,
      color: 'white'
    },

    userInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      color: 'white'
    },

    avatar: {
      width: isMobile ? '35px' : '45px',
      height: isMobile ? '35px' : '45px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255,255,255,0.2)',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      border: '2px solid rgba(255,255,255,0.3)'
    },

    mobileMenuBtn: {
      background: 'rgba(255,255,255,0.2)',
      border: 'none',
      color: 'white',
      padding: '8px',
      borderRadius: '8px',
      cursor: 'pointer',
      display: isMobile ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center'
    },

    // Main content
    mainContent: {
      display: 'flex',
      marginTop: isMobile ? '20px' : '30px',
      gap: isMobile ? '15px' : '25px',
      flexDirection: isMobile ? 'column' : 'row'
    },

    // Sidebar
    sidebar: {
      flex: isMobile ? '0 0 auto' : '0 0 280px',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
      padding: isMobile ? '15px' : '20px 0',
      height: isMobile ? 'auto' : 'fit-content',
      display: isMobile && !sidebarOpen ? 'none' : 'block',
      position: isMobile ? 'fixed' : 'relative',
      top: isMobile ? '0' : 'auto',
      left: isMobile ? '0' : 'auto',
      width: isMobile ? '280px' : 'auto',
      height: isMobile ? '100vh' : 'auto',
      zIndex: isMobile ? 99 : 'auto',
      overflowY: isMobile ? 'auto' : 'visible'
    },

    sidebarOverlay: {
      display: isMobile && sidebarOpen ? 'block' : 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 98
    },

    sidebarMenu: {
      listStyle: 'none',
      margin: 0,
      padding: 0
    },

    sidebarMenuItem: {
      padding: isMobile ? '14px 20px' : '16px 25px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      cursor: 'pointer',
      transition: 'all 0.3s',
      borderLeft: '4px solid transparent',
      fontSize: isMobile ? '14px' : '15px',
      color: '#718096',
      textDecoration: 'none'
    },

    sidebarMenuItemActive: {
      backgroundColor: 'rgba(227, 99, 36, 0.1)',
      color: '#E36324',
      borderLeft: '4px solid #E36324'
    },

    // Content area
    content: {
      flex: 1,
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
      padding: isMobile ? '20px' : '30px',
      border: '1px solid #E2E8F0'
    },

    contentHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: isMobile ? 'flex-start' : 'center',
      marginBottom: isMobile ? '20px' : '30px',
      paddingBottom: isMobile ? '15px' : '25px',
      borderBottom: '2px solid #F7FAFC',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '15px' : '0'
    },

    contentTitle: {
      fontSize: isMobile ? '1.4rem' : '1.75rem',
      fontWeight: 700,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      color: '#2D3748'
    },

    headerActions: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap'
    },

    // Buttons
    btn: {
      padding: isMobile ? '10px 16px' : '12px 20px',
      borderRadius: '10px',
      border: 'none',
      cursor: 'pointer',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.3s ease',
      fontSize: isMobile ? '13px' : '14px',
      fontFamily: 'inherit',
      whiteSpace: 'nowrap'
    },

    btnPrimary: {
      background: 'linear-gradient(135deg, #E36324 0%, #FF7B42 100%)',
      color: 'white',
      boxShadow: '0 2px 4px rgba(227, 99, 36, 0.3)',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(227, 99, 36, 0.4)'
      }
    },

    btnSecondary: {
      backgroundColor: '#5DC350',
      color: 'white',
      boxShadow: '0 2px 4px rgba(93, 195, 80, 0.3)',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(93, 195, 80, 0.4)'
      }
    },

    btnDanger: {
      backgroundColor: '#E53E3E',
      color: 'white',
      boxShadow: '0 2px 4px rgba(229, 62, 62, 0.3)',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(229, 62, 62, 0.4)'
      }
    },

    btnOutline: {
      backgroundColor: 'transparent',
      color: '#718096',
      border: '2px solid #E2E8F0',
      ':hover': {
        backgroundColor: '#F7FAFC',
        borderColor: '#E36324',
        color: '#E36324'
      }
    },

    btnSm: {
      padding: '6px 12px',
      fontSize: '12px'
    },

    // Stats cards
    statsCards: {
      display: 'grid',
      gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: isMobile ? '15px' : '20px',
      marginBottom: isMobile ? '20px' : '30px'
    },

    statCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
      padding: isMobile ? '20px' : '25px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      transition: 'transform 0.3s, box-shadow 0.3s',
      border: '1px solid #F0F0F0',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)'
      }
    },

    statValue: {
      fontSize: isMobile ? '1.5rem' : '2rem',
      fontWeight: 700,
      color: '#E36324'
    },

    statLabel: {
      color: '#718096',
      fontSize: isMobile ? '12px' : '14px',
      fontWeight: 500
    },

    statIcon: {
      width: isMobile ? '40px' : '50px',
      height: isMobile ? '40px' : '50px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: isMobile ? '1.2rem' : '1.5rem'
    },

    statIconPrimary: {
      backgroundColor: '#E36324'
    },

    statIconSecondary: {
      backgroundColor: '#5DC350'
    },

    statIconInfo: {
      backgroundColor: '#3182CE'
    },

    statIconWarning: {
      backgroundColor: '#D69E2E'
    },

    // Search and filter
    searchFilterContainer: {
      display: 'flex',
      gap: isMobile ? '10px' : '15px',
      marginBottom: isMobile ? '20px' : '25px',
      flexWrap: 'wrap',
      flexDirection: isMobile ? 'column' : 'row'
    },

    searchInput: {
      flex: isMobile ? '0 0 100%' : 1,
      minWidth: isMobile ? 'auto' : '250px',
      padding: isMobile ? '12px 12px 12px 40px' : '12px 12px 12px 40px',
      border: '1px solid #E2E8F0',
      borderRadius: '10px',
      fontSize: isMobile ? '14px' : '1rem',
      transition: 'border-color 0.3s, box-shadow 0.3s',
      fontFamily: 'inherit'
    },

    filterSelect: {
      padding: isMobile ? '12px' : '12px',
      border: '1px solid #E2E8F0',
      borderRadius: '10px',
      fontSize: isMobile ? '14px' : '1rem',
      backgroundColor: 'white',
      minWidth: isMobile ? '100%' : '150px',
      fontFamily: 'inherit'
    },

    // Table styles
    tableContainer: {
      overflowX: 'auto',
      borderRadius: '12px',
      border: '1px solid #E2E8F0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      WebkitOverflowScrolling: 'touch'
    },

    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: isMobile ? '800px' : '900px'
    },

    tableHeader: {
      padding: isMobile ? '12px' : '16px',
      textAlign: 'left',
      borderBottom: '2px solid #E2E8F0',
      backgroundColor: '#F7FAFC',
      fontWeight: 600,
      color: '#2D3748',
      cursor: 'pointer',
      transition: 'all 0.3s',
      fontSize: isMobile ? '13px' : '14px',
      ':hover': {
        backgroundColor: '#EDF2F7'
      }
    },

    tableCell: {
      padding: isMobile ? '12px' : '16px',
      textAlign: 'left',
      borderBottom: '1px solid #E2E8F0',
      fontSize: isMobile ? '13px' : '14px'
    },

    status: {
      padding: '6px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: 600,
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      cursor: 'pointer',
      transition: 'all 0.3s',
      border: 'none'
    },

    statusActive: {
      backgroundColor: 'rgba(93, 195, 80, 0.15)',
      color: '#276749',
      ':hover': {
        backgroundColor: 'rgba(93, 195, 80, 0.25)'
      }
    },

    statusInactive: {
      backgroundColor: 'rgba(229, 62, 62, 0.15)',
      color: '#C53030',
      ':hover': {
        backgroundColor: 'rgba(229, 62, 62, 0.25)'
      }
    },

    actionButtons: {
      display: 'flex',
      gap: '6px',
      flexWrap: 'wrap'
    },

    actionBtn: {
      padding: '6px 10px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '11px',
      transition: 'all 0.3s',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontWeight: 500,
      whiteSpace: 'nowrap'
    },

    actionEdit: {
      backgroundColor: 'rgba(49, 130, 206, 0.1)',
      color: '#3182CE',
      border: '1px solid rgba(49, 130, 206, 0.2)',
      ':hover': {
        backgroundColor: 'rgba(49, 130, 206, 0.2)',
        transform: 'translateY(-1px)'
      }
    },

    actionDelete: {
      backgroundColor: 'rgba(229, 62, 62, 0.1)',
      color: '#E53E3E',
      border: '1px solid rgba(229, 62, 62, 0.2)',
      ':hover': {
        backgroundColor: 'rgba(229, 62, 62, 0.2)',
        transform: 'translateY(-1px)'
      }
    },

    actionView: {
      backgroundColor: 'rgba(113, 128, 150, 0.1)',
      color: '#718096',
      border: '1px solid rgba(113, 128, 150, 0.2)',
      ':hover': {
        backgroundColor: 'rgba(113, 128, 150, 0.2)',
        transform: 'translateY(-1px)'
      }
    },

    // Modal styles
    modal: {
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 1000,
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '10px' : '20px',
      backdropFilter: 'blur(4px)'
    },

    modalContent: {
      backgroundColor: 'white',
      borderRadius: '16px',
      width: '100%',
      maxWidth: isMobile ? '100%' : '900px',
      boxShadow: '0 20px 25px rgba(0, 0, 0, 0.15)',
      overflow: 'hidden',
      maxHeight: '90vh',
      overflowY: 'auto'
    },

    modalHeader: {
      padding: isMobile ? '20px' : '25px',
      background: 'linear-gradient(135deg, #E36324 0%, #FF7B42 100%)',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },

    modalTitle: {
      fontSize: isMobile ? '1.2rem' : '1.4rem',
      fontWeight: 600,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },

    closeBtn: {
      background: 'rgba(255,255,255,0.2)',
      border: 'none',
      color: 'white',
      fontSize: '1.5rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: isMobile ? '32px' : '36px',
      height: isMobile ? '32px' : '36px',
      borderRadius: '8px',
      transition: 'background-color 0.3s',
      ':hover': {
        backgroundColor: 'rgba(255,255,255,0.3)'
      }
    },

    modalBody: {
      padding: isMobile ? '20px' : '30px',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '20px' : '30px'
    },

    modalColumn: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },

    formGroup: {
      marginBottom: isMobile ? '15px' : '20px'
    },

    formLabel: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: 600,
      color: '#2D3748',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: isMobile ? '14px' : '15px'
    },

    formControl: {
      width: '100%',
      padding: isMobile ? '10px' : '12px',
      border: '1px solid #E2E8F0',
      borderRadius: '8px',
      fontSize: isMobile ? '14px' : '1rem',
      transition: 'border-color 0.3s, box-shadow 0.3s',
      fontFamily: 'inherit',
      resize: 'vertical'
    },

    textarea: {
      minHeight: '100px',
      resize: 'vertical'
    },

    modalFooter: {
      padding: isMobile ? '20px' : '25px',
      backgroundColor: '#F7FAFC',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px',
      borderTop: '1px solid #E2E8F0',
      flexWrap: 'wrap'
    },

    // Image preview
    imagePreview: {
      width: isMobile ? '40px' : '50px',
      height: isMobile ? '40px' : '50px',
      objectFit: 'cover',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'transform 0.3s',
      border: '1px solid #E2E8F0'
    },

    imagePreviewLarge: {
      width: '80px',
      height: '80px',
      objectFit: 'cover',
      borderRadius: '8px',
      border: '1px solid #E2E8F0'
    },

    imageModal: {
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      zIndex: 1100,
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '10px' : '20px'
    },

    imageModalContent: {
      maxWidth: '90%',
      maxHeight: '90%',
      borderRadius: '8px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
    },

    imageModalClose: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      color: 'white',
      fontSize: '2rem',
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.3s',
      ':hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }
    },

    // Image upload area
    imageUploadArea: {
      border: '2px dashed #E2E8F0',
      borderRadius: '8px',
      padding: isMobile ? '15px' : '20px',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'border-color 0.3s',
      marginBottom: '15px',
      ':hover': {
        borderColor: '#E36324'
      }
    },

    imagePreviewContainer: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      marginTop: '15px'
    },

    imagePreviewItem: {
      position: 'relative',
      display: 'inline-block'
    },

    removeImageBtn: {
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      backgroundColor: '#E53E3E',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      fontSize: '12px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    // Loading state
    loadingSpinner: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px',
      flexDirection: 'column',
      gap: '15px'
    },

    // Empty state
    emptyState: {
      textAlign: 'center',
      padding: '40px',
      color: '#718096'
    },

    // Pagination
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      marginTop: '20px',
      padding: '20px',
      flexWrap: 'wrap'
    },

    pageButton: {
      padding: '8px 12px',
      border: '1px solid #E2E8F0',
      backgroundColor: 'white',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s',
      fontSize: '14px',
      minWidth: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ':hover': {
        backgroundColor: '#F7FAFC'
      }
    },

    activePage: {
      backgroundColor: '#E36324',
      color: 'white',
      borderColor: '#E36324',
      ':hover': {
        backgroundColor: '#d4561d'
      }
    },

    // Blog card for mobile
    blogCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      border: '1px solid #E2E8F0',
      padding: '16px',
      marginBottom: '12px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
    },

    blogCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '12px'
    },

    blogCardTitle: {
      fontSize: '16px',
      fontWeight: 600,
      margin: '0 0 8px 0',
      color: '#2D3748'
    },

    blogCardMeta: {
      display: 'flex',
      gap: '12px',
      fontSize: '12px',
      color: '#718096',
      marginBottom: '12px'
    },

    blogCardImages: {
      display: 'flex',
      gap: '8px',
      marginBottom: '12px'
    },

    blogCardActions: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-end'
    }
  };

  // Render blog cards for mobile view
  const renderBlogCards = () => {
    return sortedBlogs.map(blog => {
      const createdDate = new Date(blog.created_at);
      const formattedDate = createdDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });

      const listImages = ensureListImgIsArray(blog);

      return (
        <div key={blog.id} style={styles.blogCard}>
          <div style={styles.blogCardHeader}>
            <div style={{ flex: 1 }}>
              <h3 style={styles.blogCardTitle}>{blog.title}</h3>
              <div style={styles.blogCardMeta}>
                <span>#{blog.id}</span>
                <span>{blog.category}</span>
                <span>{formattedDate}</span>
              </div>
            </div>
            <button
              style={{
                ...styles.status,
                ...(blog.status === 'active' ? styles.statusActive : styles.statusInactive)
              }}
              onClick={() => toggleBlogStatus(blog)}
            >
              {blog.status === 'active' ? <FiCheckCircle size={12} /> : <FiClock size={12} />}
            </button>
          </div>

          <div style={styles.blogCardImages}>
            <img
              src={blog.main_img}
              style={{ ...styles.imagePreview, width: '40px', height: '40px' }}
              alt="Main"
              onClick={() => showImage(blog.main_img)}
            />
            <img
              src={blog.small_img}
              style={{ ...styles.imagePreview, width: '40px', height: '40px' }}
              alt="Small"
              onClick={() => showImage(blog.small_img)}
            />
          </div>

          <div style={styles.blogCardMeta}>
            <span><FiEye size={12} /> {blog.views || 0} views</span>
            <span><FiHeart size={12} /> {blog.likes || 0} likes</span>
          </div>

          <div style={styles.blogCardActions}>
            <button
              style={{ ...styles.actionBtn, ...styles.actionView }}
              onClick={() => toast.info(`Viewing: ${blog.title}`)}
            // onClick={() => viewBlogDetails(blog)}

            >
              <FiEye size={12} />
            </button>
            <button
              style={{ ...styles.actionBtn, ...styles.actionEdit }}
              onClick={() => editBlog(blog)}
            >
              <FiEdit size={12} />
            </button>
            <button
              style={{ ...styles.actionBtn, ...styles.actionDelete }}
              onClick={() => deleteBlog(blog.id)}
            >
              <FiTrash2 size={12} />
            </button>
          </div>
        </div>
      );
    });
  };

  return (
    <div style={styles.body}>
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />



      {/* Sidebar Overlay for Mobile */}
      {isMobile && (
        <div
          style={styles.sidebarOverlay}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div style={styles.container}>
        <div style={styles.mainContent}>
          {/* Sidebar */}

          {/* Content Area */}
          <main style={styles.content}>
            <div style={styles.contentHeader}>
              <h2 style={styles.contentTitle}>
                <FaNewspaper />
                Blog Management
              </h2>
              <div style={styles.headerActions}>
                <button
                  style={{ ...styles.btn, ...styles.btnOutline }}
                  onClick={fetchBlogs}
                  disabled={loading}
                >
                  <FiRefreshCw size={16} />
                  {!isMobile && 'Refresh'}
                </button>
                <button
                  style={{ ...styles.btn, ...styles.btnPrimary }}
                  onClick={() => {
                    resetForm();
                    setShowModal(true);
                  }}
                >
                  <FiPlus size={16} />
                  {!isMobile && 'Add New Blog'}
                </button>
              </div>
            </div>

            {/* Stats Cards */}
            <div style={styles.statsCards}>
              <div style={styles.statCard}>
                <div style={{ ...styles.statIcon, ...styles.statIconPrimary }}>
                  <FaNewspaper size={isMobile ? 16 : 20} />
                </div>
                <div style={styles.statValue}>{totalBlogs}</div>
                <div style={styles.statLabel}>Total Blogs</div>
              </div>
              <div style={styles.statCard}>
                <div style={{ ...styles.statIcon, ...styles.statIconSecondary }}>
                  <FaRegEye size={isMobile ? 16 : 20} />
                </div>
                <div style={styles.statValue}>{totalViews}</div>
                <div style={styles.statLabel}>Total Views</div>
              </div>
              <div style={styles.statCard}>
                <div style={{ ...styles.statIcon, ...styles.statIconInfo }}>
                  <FaCheckCircle size={isMobile ? 16 : 20} />
                </div>
                <div style={styles.statValue}>{activeBlogs}</div>
                <div style={styles.statLabel}>Active Blogs</div>
              </div>
              <div style={styles.statCard}>
                <div style={{ ...styles.statIcon, ...styles.statIconWarning }}>
                  <FaRegClock size={isMobile ? 16 : 20} />
                </div>
                <div style={styles.statValue}>{draftBlogs}</div>
                <div style={styles.statLabel}>Draft Blogs</div>
              </div>
            </div>

            {/* Search and Filter */}
            <div style={styles.searchFilterContainer}>
              <div style={{ position: 'relative', flex: isMobile ? '0 0 100%' : 1, minWidth: isMobile ? 'auto' : '250px' }}>
                <FiSearch
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#718096'
                  }}
                  size={18}
                />
                <input
                  type="text"
                  placeholder="Search blogs..."
                  style={styles.searchInput}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#E36324';
                    e.target.style.boxShadow = '0 0 0 2px rgba(227, 99, 36, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#E2E8F0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>
              <select
                style={styles.filterSelect}
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
              <select
                style={styles.filterSelect}
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
              >
                <option value="all">All Categories</option>
                {categories.map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </div>

            {/* Data Table (Desktop) / Cards (Mobile) */}
            {isMobile ? (
              // Mobile Cards View
              <div>
                {loading ? (
                  <div style={styles.loadingSpinner}>
                    <FiRefreshCw size={24} style={{ animation: 'spin 1s linear infinite' }} />
                    <div>Loading blogs...</div>
                  </div>
                ) : sortedBlogs.length === 0 ? (
                  <div style={styles.emptyState}>
                    <FiFileText size={48} style={{ marginBottom: '10px', opacity: 0.5 }} />
                    <h3>No blogs found</h3>
                    <p>Try adjusting your search or filter criteria</p>
                  </div>
                ) : (
                  renderBlogCards()
                )}
              </div>
            ) : (
              // Desktop Table View
              <div style={styles.tableContainer}>
                {loading ? (
                  <div style={styles.loadingSpinner}>
                    <FiRefreshCw size={24} style={{ animation: 'spin 1s linear infinite' }} />
                    <div>Loading blogs...</div>
                  </div>
                ) : sortedBlogs.length === 0 ? (
                  <div style={styles.emptyState}>
                    <FiFileText size={48} style={{ marginBottom: '10px', opacity: 0.5 }} />
                    <h3>No blogs found</h3>
                    <p>Try adjusting your search or filter criteria</p>
                  </div>
                ) : (
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th
                          style={styles.tableHeader}
                          onClick={() => handleSort('id')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            ID
                            {sortConfig.key === 'id' && (
                              sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />
                            )}
                          </div>
                        </th>
                        <th
                          style={styles.tableHeader}
                          onClick={() => handleSort('title')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            Title
                            {sortConfig.key === 'title' && (
                              sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />
                            )}
                          </div>
                        </th>
                        <th
                          style={styles.tableHeader}
                          onClick={() => handleSort('category')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            Category
                            {sortConfig.key === 'category' && (
                              sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />
                            )}
                          </div>
                        </th>
                        {/* <th style={styles.tableHeader}>Author</th> */}
                        <th style={styles.tableHeader}>Images</th>
                        <th
                          style={styles.tableHeader}
                          onClick={() => handleSort('status')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            Status
                            {sortConfig.key === 'status' && (
                              sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />
                            )}
                          </div>
                        </th>
                        <th
                          style={styles.tableHeader}
                          onClick={() => handleSort('created_at')}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            Created At
                            {sortConfig.key === 'created_at' && (
                              sortConfig.direction === 'asc' ? <FaSortUp /> : <FaSortDown />
                            )}
                          </div>
                        </th>
                        <th style={styles.tableHeader}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedBlogs.map(blog => {
                        const createdDate = new Date(blog.created_at);
                        const formattedDate = createdDate.toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        });

                        const listImages = ensureListImgIsArray(blog);

                        return (
                          <tr key={blog.id}>
                            <td style={styles.tableCell}>
                              <strong>#{blog.id}</strong>
                            </td>
                            <td style={styles.tableCell}>
                              <div>
                                <strong style={{ display: 'block', marginBottom: '5px' }}>{blog.title}</strong>
                                {blog.excerpt && (
                                  <small style={{ color: '#718096', fontSize: '12px' }}>
                                    {blog.excerpt.substring(0, 60)}...
                                  </small>
                                )}
                                <div style={{ display: 'flex', gap: '15px', marginTop: '5px', fontSize: '12px', color: '#718096' }}>
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <FiEye size={12} /> {blog.views || 0}
                                  </span>
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <FiHeart size={12} /> {blog.likes || 0}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td style={styles.tableCell}>
                              <span style={{
                                backgroundColor: 'rgba(227, 99, 36, 0.1)',
                                color: '#E36324',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '0.8rem',
                                fontWeight: '500'
                              }}>
                                {blog.category}
                              </span>
                            </td>
                            {/* <td style={styles.tableCell}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%',
                                  backgroundColor: 'rgba(113, 128, 150, 0.1)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  color: '#718096'
                                }}>
                                  <FiUser size={14} />
                                </div>
                                <span>{blog.author || 'Unknown'}</span>
                              </div>
                            </td> */}
                            <td style={styles.tableCell}>
                              <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                                {blog.main_img ? (
                                  <img
                                    src={blog.main_img}
                                    style={styles.imagePreview}
                                    alt="Main"
                                    onClick={() => showImage(blog.main_img)}
                                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                  />
                                ) : null}
                                {blog.small_img ? (
                                  <img
                                    src={blog.small_img}
                                    style={styles.imagePreview}
                                    alt="Small"
                                    onClick={() => showImage(blog.small_img)}
                                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                  />) : null}
                                {listImages.slice(0, 2).map((img, index) => (
                                  <img
                                    key={index}
                                    src={img}
                                    style={styles.imagePreview}
                                    alt={`List ${index + 1}`}
                                    onClick={() => showImage(img)}
                                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                  />
                                ))}
                                {listImages.length > 2 && (
                                  <div style={{
                                    ...styles.imagePreview,
                                    backgroundColor: '#F7FAFC',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#718096',
                                    fontSize: '12px'
                                  }}>
                                    +{listImages.length - 2}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td style={styles.tableCell}>
                              <button
                                style={{
                                  ...styles.status,
                                  ...(blog.status === 'active' ? styles.statusActive : styles.statusInactive)
                                }}
                                onClick={() => toggleBlogStatus(blog)}
                              >
                                {blog.status === 'active' ? <FiCheckCircle size={12} /> : <FiClock size={12} />}
                                {/* {blog.status.charAt(0).toUpperCase() + blog.status.slice(1)} */}
                                {capitalize(blog.status) || 'Unknown'}

                              </button>
                            </td>
                            <td style={styles.tableCell}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <FiCalendar size={12} style={{ color: '#718096' }} />
                                {formattedDate}
                              </div>
                            </td>
                            <td style={styles.tableCell}>
                              <div style={styles.actionButtons}>
                                <button
                                  style={{ ...styles.actionBtn, ...styles.actionView }}
                                  // onClick={() => toast.info(`Viewing: ${blog.title}`)}
                                  onClick={() => viewBlogDetails(blog)}
                                >
                                  <FiEye size={14} />
                                  View
                                </button>
                                <button
                                  style={{ ...styles.actionBtn, ...styles.actionEdit }}
                                  onClick={() => editBlog(blog)}
                                >
                                  <FiEdit size={14} />
                                  Edit
                                </button>
                                <button
                                  style={{ ...styles.actionBtn, ...styles.actionDelete }}
                                  onClick={() => deleteBlog(blog.id)}
                                >
                                  <FiTrash2 size={14} />
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={styles.pagination}>
                <button
                  style={styles.pageButton}
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 1}
                >
                  <FiChevronLeft />
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    style={{
                      ...styles.pageButton,
                      ...(page === index + 1 ? styles.activePage : {})
                    }}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  style={styles.pageButton}
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page === totalPages}
                >
                  <FiChevronRight />
                </button>
              </div>
            )}
          </main>
        </div>
      </div>

      {/* Add/Edit Blog Modal */}
      {showModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>
                <FaNewspaper />
                {editingBlog ? 'Edit Blog' : 'Add New Blog'}
              </h3>
              <button
                style={styles.closeBtn}
                onClick={() => setShowModal(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
              >
                <FiX />
              </button>
            </div>
            <div style={styles.modalBody}>
              {/* Left Column - Basic Info */}
              <div style={styles.modalColumn}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="title">
                    <FiEdit />
                    Title
                  </label>
                  <input
                    type="text"
                    style={styles.formControl}
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#E36324';
                      e.target.style.boxShadow = '0 0 0 2px rgba(227, 99, 36, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#E2E8F0';
                      e.target.style.boxShadow = 'none';
                    }}
                    required
                    placeholder="Enter blog title"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="category">
                    <FiFileText />
                    Category
                  </label>
                  <input
                    type="text"
                    style={styles.formControl}
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#E36324';
                      e.target.style.boxShadow = '0 0 0 2px rgba(227, 99, 36, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#E2E8F0';
                      e.target.style.boxShadow = 'none';
                    }}
                    required
                    placeholder="Enter blog category"
                  />
                </div>

                {/* <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="author">
                    <FiUser />
                    Author
                  </label>
                  <input 
                    type="text" 
                    style={styles.formControl} 
                    id="author" 
                    name="author"
                    value={formData.author}
                    onChange={handleInputChange}
                    placeholder="Enter author name"
                  />
                </div> */}

                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="tags">
                    <FiFileText />
                    Tags
                  </label>
                  <input
                    type="text"
                    style={styles.formControl}
                    id="tags"
                    name="tags"
                    value={formData.tags}
                    onChange={handleInputChange}
                    placeholder="Enter tags (comma separated)"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="status">
                    <FiCheckCircle />
                    Status
                  </label>
                  <select
                    style={styles.formControl}
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>

              {/* Right Column - Content & Images */}
              <div style={styles.modalColumn}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="excerpt">
                    <FiFileText />
                    Excerpt
                  </label>
                  <textarea
                    style={{ ...styles.formControl, ...styles.textarea }}
                    id="excerpt"
                    name="excerpt"
                    value={formData.excerpt}
                    onChange={handleInputChange}
                    placeholder="Enter blog excerpt"
                    rows="3"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel} htmlFor="content">
                    <FiFileText />
                    Content
                  </label>
                  <textarea
                    style={{ ...styles.formControl, ...styles.textarea }}
                    id="content"
                    name="content"
                    value={formData.content}
                    onChange={handleInputChange}
                    placeholder="Enter blog content"
                    rows="5"
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>
                    <FiImage />
                    Images
                  </label>

                  {/* Main Image */}
                  <div style={styles.imageUploadArea}>
                    <label style={{ cursor: 'pointer', display: 'block' }}>
                      <FiUpload style={{ marginRight: '5px' }} />
                      Main Image
                      <input
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => handleImageUpload(e, 'main_img')}
                        accept="image/*"
                      />
                    </label>
                    {imagePreviews.main_img && (
                      <div style={styles.imagePreviewContainer}>
                        <div style={styles.imagePreviewItem}>
                          <img
                            src={imagePreviews.main_img}
                            style={styles.imagePreviewLarge}
                            alt="Main preview"
                          />
                          <button
                            style={styles.removeImageBtn}
                            onClick={() => removeImage('main_img')}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Small Image */}
                  <div style={styles.imageUploadArea}>
                    <label style={{ cursor: 'pointer', display: 'block' }}>
                      <FiUpload style={{ marginRight: '5px' }} />
                      Small Image
                      <input
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => handleImageUpload(e, 'small_img')}
                        accept="image/*"
                      />
                    </label>
                    {imagePreviews.small_img && (
                      <div style={styles.imagePreviewContainer}>
                        <div style={styles.imagePreviewItem}>
                          <img
                            src={imagePreviews.small_img}
                            style={styles.imagePreviewLarge}
                            alt="Small preview"
                          />
                          <button
                            style={styles.removeImageBtn}
                            onClick={() => removeImage('small_img')}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* List Images */}
                  <div style={styles.imageUploadArea}>
                    <label style={{ cursor: 'pointer', display: 'block' }}>
                      <FiUpload style={{ marginRight: '5px' }} />
                      List Images
                      <input
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => handleImageUpload(e, 'list_img')}
                        accept="image/*"
                        multiple
                      />
                    </label>
                    {imagePreviews.list_img.length > 0 && (
                      <div style={styles.imagePreviewContainer}>
                        {imagePreviews.list_img.map((preview, index) => (
                          <div key={index} style={styles.imagePreviewItem}>
                            <img
                              src={preview}
                              style={styles.imagePreviewLarge}
                              alt={`List preview ${index + 1}`}
                            />
                            <button
                              style={styles.removeImageBtn}
                              onClick={() => removeImage('list_img', index)}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div style={styles.modalFooter}>
              <button
                style={{ ...styles.btn, ...styles.btnOutline }}
                onClick={() => setShowModal(false)}
                disabled={loading}
              >
                <FiX style={{ marginRight: '5px' }} />
                Cancel
              </button>
              <button
                style={{ ...styles.btn, ...styles.btnPrimary }}
                onClick={saveBlog}
                disabled={loading}
              >
                {loading ? (
                  <>Loading...</>
                ) : (
                  <>
                    <FiSave style={{ marginRight: '5px' }} />
                    {editingBlog ? 'Update Blog' : 'Save Blog'}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* View Blog Modal */}
      {showViewModal && viewBlog && (
        <div style={styles.modal} onClick={() => setShowViewModal(false)}>
          <div
            style={styles.modalContent}
            onClick={(e) => e.stopPropagation()} // prevent outer click from closing when interacting inside
          >
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>
                <FaNewspaper />
                 {viewBlog.title || 'Untitled'}
              </h3>
              <button
                style={styles.closeBtn}
                onClick={() => setShowViewModal(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
              >
                <FiX />
              </button>
            </div>

            <div style={styles.modalBody}>
              <div style={{ ...styles.modalColumn, flex: 1 }}>
                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiEdit />Title</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {viewBlog.title}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiFile />Category</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {viewBlog.category || '-'}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiFileText />Excerpt</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {viewBlog.excerpt || '-'}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiFileText />Content</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8, whiteSpace: 'pre-wrap' }}>
                    {viewBlog.content || '-'}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}> <FiFile />Tags</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {viewBlog.tags || '-'}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.modalColumn, maxWidth: 320 }}>
                <div style={styles.formGroup}>
                  <div style={styles.formLabel}> <FiCheckCircle />Status</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {capitalize(viewBlog.status) || '-'}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiInfo />Created</div>
                  <div style={{ padding: '8px 12px', border: '1px solid #E2E8F0', borderRadius: 8 }}>
                    {viewBlog.created_at || '-'}
                  </div>
                </div>

                <div style={styles.formGroup}>
                  <div style={styles.formLabel}><FiImage />Images</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {viewBlog.main_img ? (
                      <img
                        src={viewBlog.main_img}
                        alt="main"
                        style={styles.imagePreviewLarge}
                        onClick={() => showImage(viewBlog.main_img)}
                      />
                    ) : null}
                    {viewBlog.small_img ? (
                      <img
                        src={viewBlog.small_img}
                        alt="small"
                        style={styles.imagePreviewLarge}
                        onClick={() => showImage(viewBlog.small_img)}
                      />
                    ) : null}
                    {(viewBlog.list_img || []).slice(0, 6).map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt={`list-${i}`}
                        style={styles.imagePreviewLarge}
                        onClick={() => showImage(src)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div style={styles.modalFooter}>
              <button
                style={{ ...styles.btn, ...styles.btnOutline }}
                onClick={() => setShowViewModal(false)}
              >
                <FiX style={{ marginRight: 6 }} /> Close
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Image Preview Modal */}
      {showImageModal && (
        <div style={styles.imageModal}>
          <span
            style={styles.imageModalClose}
            onClick={() => setShowImageModal(false)}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.5)'}
          >
            <FiX />
          </span>
          <img
            style={styles.imageModalContent}
            src={selectedImage}
            alt="Preview"
          />
        </div>
      )}
    </div>
  );
};

export default BlogDashboard;
